<ng-container
  *ngIf="{
    pagesGrid: pagesGrid$ | async,
  } as content"
>
  <div class="container-content-page-grid" *ngIf="content?.pagesGrid?.pages?.length">
    <div class="container">
      <div class="box-titles">
        <p *ngIf="content.pagesGrid?.line1" class="line-1">{{ content.pagesGrid?.line1 }}</p>
        <p *ngIf="content.pagesGrid?.line2" class="line-2">{{ content.pagesGrid?.line2 }}</p>
      </div>

      <div class="cards" [ngClass]="'container-of-' + (content?.pagesGrid?.pages)!.length">
        <div class="card" *ngFor="let page of content?.pagesGrid?.pages">
          <a [routerLink]="page.label">
            <img [src]="page.previewImage?.url" alt="" />
          </a>

          <a class="line-1" [routerLink]="page.label">
            {{ page.line1 }}
          </a>

          <div class="content m-t-20 line-2" [innerHTML]="page.line2"></div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
